export default "__VITE_ASSET__BfwDySZw__"